import { render } from "./AdminHomeLayout.vue?vue&type=template&id=24ff709a&scoped=true"
import script from "./AdminHomeLayout.vue?vue&type=script&lang=js"
export * from "./AdminHomeLayout.vue?vue&type=script&lang=js"

import "./AdminHomeLayout.vue?vue&type=style&index=0&id=24ff709a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ff709a"]])

export default __exports__